import { render, staticRenderFns } from "./Helpcenter.vue?vue&type=template&id=41891484"
import script from "./Helpcenter.vue?vue&type=script&lang=js"
export * from "./Helpcenter.vue?vue&type=script&lang=js"
import style0 from "./Helpcenter.vue?vue&type=style&index=0&id=41891484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports